<template>
  <default-layout>
    <section slot="content">
      <v-container
        fluid
      >
        <v-row justify="center" class="mt-10" v-if="order && order.client">
          <template>
            <v-col cols="12">
              <div>
                <v-alert
                  border="bottom"
                  colored-border
                  type="warning"
                  elevation="2"
                >
                  Nos contactaremos con usted para la validacion de su compra, gracias por la preferencia.
                  N° Pedido: <b>{{ zfill(order.id, 9) + '-' + order.client_id }}</b>
                  <br><br>
                  <template v-if="order.payment_type_id == 1">
                    DETALLE DE PAGO: YAPE - Número 987839662<br>
                  </template>
                  <template v-else-if="order.payment_type_id == 2">
                    DETALLE DE PAGO: Transferencia Bancaria<br>
                    <b>INTERBANK SOLES</b><br>
                    898 3313913343<br>
                    Sayda Cuaresma Olarte<br><br>
                    <b>BCP SOLES</b><br>
                    194-94958085-0-54<br>
                    Sayda Cuaresma Olarte<br>
                  </template>
                  <template v-else>
                    DETALLE DE PAGO: Pago Contra Entrega<br>
                  </template>
                </v-alert>
              </div>
            </v-col>
          </template>
          <v-col cols="12" md="10" xs="12">
            <v-row justify="center">
              <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                <template>
                  <v-card
                    class="mx-auto"
                    height="190"
                  >
                    <v-card-text>
                      <p class="text-h5 text--primary">
                        Datos Personales
                      </p>
                      <div class="text--primary">
                        {{ order.client.name }} {{ order.client.last_name }}<br>
                        {{ order.client.identification_doc }}<br>
                        {{ order.client.phone }}<br>
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>

              <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                <template>
                  <v-card
                    class="mx-auto"
                    height="190"
                  >
                    <v-card-text>
                      <p class="text-h5 text--primary">
                        Medio de Pago
                      </p>
                      <div class="text--primary">
                        <template v-if="order.payment_type_id == 1">
                          YAPE<br>
                        </template>
                        <template v-else-if="order.payment_type_id == 2">
                          Transferencia Bancaria<br>
                        </template>
                        <template v-else>
                          Pago Contra Entrega<br>
                        </template>
                        <p class="body-1"><strong>S/ {{ order.total }}</strong></p>
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>

              <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                <template>
                  <v-card
                    class="mx-auto"
                    height="190"
                  >
                    <v-card-text>
                      <p class="text-h5 text--primary">
                        Resumen de Compra
                      </p>
                      <div class="text--primary">
                        <v-row no-gutters>
                          <v-col cols="6" md="6" sm="5" xs="6">
                            <v-card class="body-2 text-left" style="border: 0px" outlined elevation="0">
                              Subtotal
                            </v-card>
                          </v-col>
                          <v-col cols="6" md="6" sm="3" xs="6">
                            <v-card class="body-2 text-right" style="border: 0px" outlined elevation="0">
                              S/ {{ order.subtotal }}
                            </v-card>
                          </v-col>
                          <v-col cols="6" md="6" sm="5" xs="6">
                            <v-card class="body-2 text-left" style="border: 0px" outlined elevation="0">
                              Envío
                            </v-card>
                          </v-col>
                          <v-col cols="6" md="6" sm="3" xs="6">
                            <v-card class="body-2 text-right" style="border: 0px" outlined elevation="0">
                              S/ {{ order.shipping_price }}
                            </v-card>
                          </v-col>
                          <template v-if="order.coupon > 0">
                            <v-col cols="6" md="6" sm="3" xs="6">
                              <v-card class="body-2 text-left" style="border: 0px" outlined elevation="0">
                                Cupón
                              </v-card>
                            </v-col>
                            <v-col cols="6" md="6" sm="3" xs="6">
                              <v-card class="body-2 text-right" style="border: 0px" outlined elevation="0">
                                - S/ {{ order.coupon }}
                              </v-card>
                            </v-col>
                          </template>
                          <v-col cols="12" sm="12">
                            <v-card-title primary-title>
                              <v-divider></v-divider>
                            </v-card-title>
                          </v-col>
                          <v-col cols="6" md="6" sm="5" xs="6">
                            <v-card class="body-1 text-left" style="border: 0px" outlined elevation="0">
                              <strong>Total</strong>
                            </v-card>
                          </v-col>
                          <v-col cols="6" md="6" sm="3" xs="6">
                            <v-card class="body-1 text-right" style="border: 0px" outlined elevation="0">
                              <strong>S/ {{ order.total }}</strong>
                            </v-card>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>

              <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                <template>
                  <v-card
                    class="mx-auto"
                    height="180"
                  >
                    <v-card-text>
                      <p class="text-h5 text--primary">
                        Recepción
                      </p>
                      <div class="text--primary">
                        <template v-if="order.person_reception == 1">
                          {{ order.client.name }} {{ order.client.last_name }}<br>
                          {{ order.client.identification_doc }}<br>
                        </template>
                        <template v-else>
                          {{ order.name_reception }} {{ order.last_name_reception }}<br>
                          {{ order.identification_doc_reception }}<br>
                        </template>
                        {{ order.address.address }}<br>
                        {{ order.address.reference }}
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>

              <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                <template>
                  <v-card
                    class="mx-auto"
                    height="180"
                  >
                    <v-card-text>
                      <p class="text-h5 text--primary">
                        Programada
                      </p>
                      <div class="text--primary">
                        {{ formatDate(order.delivery_day) }}
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>

              <v-col cols="12" lg="8" md="12" sm="12" xs="12">
                <v-card>
                  <v-virtual-scroll :items="orderDetail" :item-height="112" :height="heightScroll" style="overflow-y: auto !important">
                    <template v-slot="{ item, index }">
                      <v-card-title>
                        <v-row no-gutters>
                          <v-col cols="4" md="4" sm="4" xs="2">
                            <v-card class="overline text-center" style="border: 0" outlined elevation="0">
                              <v-badge
                                color="primary"
                                overlap
                                :content="item.quantity"
                              >
                                <v-avatar size="80" tile>
                                  <v-img :src="item.product_color.product_color_image[0].image"></v-img>
                                </v-avatar>
                              </v-badge>
                            </v-card>
                          </v-col>
                          <v-col cols="4" md="5" sm="5" xs="7">
                            <v-card class="body-2 text-left name-product" style="border: 0px" outlined elevation="0">
                              {{ item.product.name.toUpperCase() }}
                            </v-card>
                          </v-col>
                          <v-col cols="4" md="3" sm="3" xs="3">
                            <v-card class="body-2 text-right" style="border: 0px" outlined elevation="0">
                              S/ {{ item.amount }}
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-title>
                    </template>
                  </v-virtual-scroll>
                </v-card>
              </v-col>

            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'

  export default {
    name: 'PurchaseMade',
    components: {
      DefaultLayout
    },
    data () {
      return {
        order: {},
        orderDetail: []
      }
    },
    computed: {
      heightScroll () {
        if (this.orderDetail.length > 5) {
          return 549;
        } else {
          return 112 * this.orderDetail.length;
        }
      }
    },
    methods: {
      getOrder () {
        axios.get(process.env.DINO.PATH.FIND_ORDER_DETAIL.replace(':orderNumber', this.$route.params.orderNumber))
        .then(response => {
          this.order = response.data.order;
          this.orderDetail = response.data.orderDetail;
        })
        .catch(err => {
        });
      },

      getImage (image) {
        try {
          return require('@/assets/img' + image);
        } catch (e) {
          return require('@/assets/img/products/default-image-notfound.jpg');
        }
      },

      formatDate: function(date) {
        moment.locale('es');
        let newDate = moment(date, 'yyyy-MM-DD');
        return 'Para ' + moment(newDate).format('DD') + ' de ' + moment(newDate).format('MMMM') + ' de ' + moment(newDate).format("yyyy");
      },

      zfill: function(number, width) {
        var numberOutput = Math.abs(number);
        var length = number.toString().length;
        var zero = "0";

        if (width <= length) {
            if (number < 0) {
                 return ("-" + numberOutput.toString());
            } else {
                 return numberOutput.toString();
            }
        } else {
            if (number < 0) {
                return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
            } else {
                return ((zero.repeat(width - length)) + numberOutput.toString());
            }
        }
      }
    },
    mounted: function () {
      this.getOrder();
    }
  }
</script>
<style scoped>
.name-product {
  word-break: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/PurchaseMade.vue